import React from 'react'
import { Redirect } from 'react-router-dom'

import AddonViewPage from '../Add-ons/AddonViewPage'
import { IPageParams } from '../../types/data'
import { FrontendUrls } from '../../types/urls'

const ADDON_TYPE_BY_INTEGRATION = new Map([
  ['api', 'open-api'],
  ['zapier', 'zapier'],
  ['adp', 'adp'],
])

interface IntegrationDetailRouteProps {
  match: IPageParams['match'] & { params: IPageParams['match']['params'] & { integrationType: string } }
}

export function IntegrationDetailRoute({ match }: IntegrationDetailRouteProps): React.ReactElement {
  const addonType = ADDON_TYPE_BY_INTEGRATION.get(match.params.integrationType)
  if (!addonType) return <Redirect to={FrontendUrls.integrations} />
  // AddonViewPage reads its type once on mount, so switching integrations must remount it.
  return <AddonViewPage key={addonType} match={{ ...match, params: { ...match.params, addonType } }} />
}

export default IntegrationDetailRoute
